import styles from "./TruncatedTitle.module.scss";
import { clsx } from "clsx";
import { ManageAsset } from "../../api/decimal/common-types/manageAssets.ts";

export default function TruncatedTitle({
  className,
  asset,
}: {
  className?: string;
  asset: ManageAsset | VST.Bridge.Asset;
}) {
  return <span className={clsx(styles.title, className)}>{asset.title}</span>;
}
